import {
  ComponentsResponse,
  ResponseObject,
  SchemaType,
} from "../../../yaml-content";
import ResponseSchemaDatatypes from "./response_schema_datatypes";
import React, { useEffect, useState } from "react";

type Props = {
  responses: ResponseObject[];
  componentResponses: ComponentsResponse[] | null;
  componentSchemas: SchemaType[] | null;
};

const ResponseTable = ({
  responses,
  componentResponses,
  componentSchemas,
}: Props) => {
  const [responseRefs, setResponseRefs] = useState<
    (ComponentsResponse | undefined)[]
  >([]);
  const [schemaRefs, setSchemaRefs] = useState<SchemaType[][]>([]);

  useEffect(() => {
    // Initialize responseRefs and schemaRefs whenever responses change
    const newResponseRefs = responses.map((response) =>
      fillResponseRef(response),
    );
    setResponseRefs(newResponseRefs);

    const newSchemaRefs = responses.map((response) => fillSchemaRef(response));
    setSchemaRefs(newSchemaRefs);
  }, [responses, componentResponses, componentSchemas]);

  function fillResponseRef(response: any): ComponentsResponse | undefined {
    if (componentResponses) {
      const ref = componentResponses.find(
        (item) => item.path === response.$ref,
      );
      return ref || undefined;
    }
    return undefined;
  }

  function findSchema(ref: string | null): SchemaType | null {
    const response = componentSchemas?.find((item) => item.path === ref);
    if (response) {
      return response;
    }
    return null;
  }

  function fillSchemaRef(response: any): SchemaType[] {
    const schemas: SchemaType[] = [];
    const appJsonSchema = response.content?.["application/json"]?.schema;

    if (appJsonSchema && appJsonSchema.$ref) {
      const schemaType = findSchema(appJsonSchema.$ref);
      if (schemaType) schemas.push(schemaType);
    }

    const responseRef = fillResponseRef(response); // Get the response reference

    if (responseRef?.content["application/json"].schema.$ref) {
      const schemaType = findSchema(
        responseRef.content["application/json"].schema.$ref,
      );
      if (schemaType) schemas.push(schemaType);
    }

    if (responseRef?.content["application/json"].schema.oneOf) {
      responseRef.content["application/json"].schema.oneOf.forEach((value) => {
        const schemaType = findSchema(value.$ref);
        if (schemaType) schemas.push(schemaType);
      });
    }

    return schemas;
  }

  return (
    <div className="sect4">
      <div>
        <div className="relative">
          <div
            className="anchor absolute inset-0 -z-50 -top-[90px] bottom-[90px] lg:-top-[120px] lg:bottom-[120px]"
            id="_responses_5"
          />
          Responses
        </div>
      </div>

      <table className="tableblock frame-all grid-all stretch">
        <thead>
          <tr>
            <th className="tableblock halign-center valign-top min-w-[60px]">Code</th>
            <th className="tableblock halign-center valign-top">Message</th>
            <th className="tableblock halign-center valign-top">Datatype</th>
          </tr>
        </thead>
        <tbody>
          {responses.map((response, index) => (
            <tr key={index}>
              <td className="tableblock halign-center valign-middle">
                {response.code}
              </td>
              <td className="tableblock halign-left valign-middle">
                {responseRefs[index]?.description}
                {response?.description}
              </td>
              <td className="tableblock halign-left valign-middle">
                <ResponseSchemaDatatypes schemaRef={schemaRefs[index]} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default ResponseTable;
